import {css} from 'lit';

export default css`

.search-popup {
  padding: 1rem;
  border-bottom: 1px solid #fff;
}
@media (min-width: 992px) {
  .search-popup {
    position: absolute;
    z-index: 850;
    right: 0;
    left: 0;
    display: flex;
    align-items: center;
    visibility: hidden;
    height: 8em;
    padding: initial;
    border-color: #999;
    background-color: #fff;
    opacity: 0;
    text-align: center;
    transition: opacity 0.3s;
  }
}
@media (min-width: 992px) {
  .search-popup .search-form {
    width: 60%;
    margin: 2rem auto;
  }
}
.search-popup.is-open {
  visibility: visible;
  opacity: 1;
}
.search-popup__open {
  margin-left: 1rem;
  display: none;
  align-items: center;
  margin-right: -2px;
  padding: 0;
  border: 0;
  background-color: #14447a;
}
.search-popup__open:before {
  width: 1rem;
  height: 3.25rem;
  margin-right: 0.5rem;
  margin-left: -1rem;
  background-color: #14447a;
  clip-path: polygon(93% 0, 110% 0, 110% 102%, 0% 102%);
  content: "";
}
.search-popup__open:focus:before, .search-popup__open:hover:before {
  background-color: #ffbf00;
}
.search-popup__open:after {
  z-index: 1;
  width: 1rem;
  height: 3.25rem;
  margin-right: -1rem;
  margin-left: 0.5rem;
  background-color: #14447a;
  clip-path: polygon(-2px -2px, 100% -2px, 7% 102%, -2px 100%);
  content: "";
}
.search-popup__open:focus:after, .search-popup__open:hover:after {
  background-color: #ffbf00;
}
@media (min-width: 992px) {
  .search-popup__open {
    display: flex;
  }
}
.search-popup__open:focus, .search-popup__open:hover {
  background-color: #ffbf00;
  color: #022851;
  outline: none;
}
.search-popup--edge .search-popup__open {
  padding-right: 0.5rem;
}
.search-popup__open:before {
  margin-right: 0.15rem;
}
.search-popup__open:after {
  margin-left: 0.15rem;
}
.search-popup__open-icon {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  overflow: hidden;
  width: 2.4375rem;
  height: 2.4375rem;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background-color: #022851;
  background-size: 50%;
  color: #fff;
  text-indent: inherit;
}
.search-popup__open-icon:before {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  margin: 0;
  content: '\\f002';
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
}
.search-popup__open--close .search-popup__open-icon:before {
  content: '\\f00d';
  font-size: 1.15em;
}
.search-popup__open-icon--close:before {
  content: '\\f00d';
}
.search-popup__close-icon {
  display: block;
  width: 2.1rem;
  height: 3px;
  background-color: #999;
  transform: rotate(45deg);
}
.search-popup__close-icon:before {
  position: absolute;
  z-index: 830;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #999;
  content: "";
  transform: rotate(90deg);
}

`;